import { render, staticRenderFns } from "./ClaimsDashboardView.vue?vue&type=template&id=c55258aa&scoped=true&"
import script from "./ClaimsDashboardView.vue?vue&type=script&lang=js&"
export * from "./ClaimsDashboardView.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsDashboardView.vue?vue&type=style&index=0&id=c55258aa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55258aa",
  null
  
)

export default component.exports